export enum SupplementalRuleChangeDataType {
    String = 0,
    Double = 1,
}
